import { toast } from '@/hooks/use-toast';
import axios from 'axios';
import axiosRetry from 'axios-retry';

export const XHRAuthorizedClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:4002/api/v1',
});

export const XHRClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:4002/api/v1',
});

axiosRetry(XHRAuthorizedClient, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
});

axiosRetry(XHRClient, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
});

// JWT 토큰 인터셉터
XHRAuthorizedClient.interceptors.request.use(
  (config) => {
    try {
      const storedData = localStorage.getItem('login-storage');
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        const accessToken = parsedData.state?.accessToken;
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
      }
    } catch (error) {
      console.error('Failed to add auth token:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터 - 401 에러 처리
XHRAuthorizedClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // 이미 홈 페이지에 있다면 토스트를 표시하지 않음 (로그아웃 상황)
      const currentPath = window.location.pathname;
      const isAlreadyAtHome = currentPath === '/';

      // 토큰이 이미 제거된 상태라면 로그아웃 중인 상황으로 간주
      const storedData = localStorage.getItem('login-storage');
      const hasValidToken =
        storedData && JSON.parse(storedData).state?.accessToken;

      if (!isAlreadyAtHome && hasValidToken) {
        // 정상적인 세션 만료 상황에서만 토스트 표시
        toast({
          variant: 'destructive',
          title: '인증 실패',
          description: '로그인이 만료되었습니다. 다시 로그인해 주세요.',
          position: 'top-center',
        });
      }

      // 홈에 있지 않다면 리다이렉트
      if (!isAlreadyAtHome) {
        setTimeout(() => {
          window.location.href = '/';
        }, 1000);
      }

      // 토큰 제거
      localStorage.removeItem('login-storage');
    }
    return Promise.reject(error);
  }
);
